// DO NOT EDIT -- generated from fs/services/capnhook/options.proto

import * as flags from '../../shared/flags';

export interface EventOptions {
  /**
   * The release state of the webhook event. By default the release state of
   * the webhook event is EXPERIMENT.
   */
  state: ReleaseState;
  /**
   * Indicates a user-friendly display name for the event type whose payload
   * is defined by this message.
   */
  displayName: string;
  /**
   * Indicates that this event should be disabled for an org if they do not
   * have the these flag enabled as part of their plan. For example, events
   * related to native mobile should be disabled for orgs that aren't paying
   * for native mobile features.
   */
  requiredFlag: flags.Flag[];
  /**
   * If set, the name of a field in the event payload message that indicates
   * the "sub-event" name. The sub-event is used for events where an endpoint
   * only wants to subscribe to a subset of the events. They can filter which
   * subset of events to receive by selecting one or more "sub-event" names.
   * For example, custom events use the custom event name as the sub-event
   * name. This allows an endpoint to receive notices only for a particular
   * custom event, instead of all of them.
   */
  subEventField: string;
}

/** Api doc will be generated for release states other than EXPERIMENT. */
export enum ReleaseState {
  /**
   * Indicates that the webhook event is experimental. This event will be hidden and cannot be subscribed to, unless
   * explicitly made available with feature flags.
   */
  EXPERIMENT = 0,
  /**
   * General Availability. Indicates that the webhook event is ready to be consumed by all customers. The webhook
   * event will be shown in the UI and be available to be subscribed to.
   */
  GA = 1,
  /** The webhook event is available for a limited number of users, or for testing. */
  BETA = 2
}
